import Hotjar from "@hotjar/browser";

const siteId = 3743259;
const hotjarVersion = 6;

// if (process.env.DEVMODE === "PROD") {
  Hotjar.init(siteId, hotjarVersion);
// }
